import { bootstrapApplication } from 'app/bootstrap';
import { installFrameBatchedResizeObserver } from 'shared/lib/installFrameBatchedResizeObserver';
import { installTransitionCompletionGuard } from 'shared/lib/installTransitionCompletionGuard';

installFrameBatchedResizeObserver();
installTransitionCompletionGuard();
bootstrapApplication();
